import { default as http } from "../rest/http";

// The v3 organization endpoints are camelCase and paginated. They are not
// interchangeable with the v1 /master-data/organizations endpoints — do not
// mix their types or responses.
const BASE_PATH = "/master-data/v3/organizations";

export interface OrganizationsV3QueryParams {
  parentId?: number; // omit for top-level organizations
  search?: string;
  page: number;
  perPage: number;
}

// GET /master-data/v3/organizations — one page of orgs at a single hierarchy level.
export const fetchOrganizationsV3 = async (params: OrganizationsV3QueryParams) => {
  const query = new URLSearchParams();
  if (params.parentId != null) query.append("parentId", String(params.parentId));
  if (params.search) query.append("search", params.search);
  query.append("page", String(params.page));
  query.append("perPage", String(params.perPage));

  const response = await http.get(`${BASE_PATH}?${query.toString()}`);
  return response;
};

// GET /master-data/v3/organizations/stats — the two summary cards. Without
// parentId the totals are system-wide; with parentId they are the recursive
// totals under that organization.
export const fetchOrganizationsV3Stats = async (parentId?: number) => {
  const url =
    parentId != null ? `${BASE_PATH}/stats?parentId=${parentId}` : `${BASE_PATH}/stats`;
  const response = await http.get(url);
  return response;
};

// GET /master-data/v3/organizations/{orgId}/deactivation-preview — cascade counts
// for the deactivate modal. Super Admin / Finley Admin only (Coach gets 403).
export const fetchDeactivationPreview = async (orgId: number) => {
  const response = await http.get(`${BASE_PATH}/${orgId}/deactivation-preview`);
  return response;
};

export interface DeactivateOrganizationBody {
  cascadeSubOrgs: boolean;
  cascadeUsers: boolean;
}

// POST /master-data/v3/organizations/{orgId}/deactivate — synchronous and one-way;
// there is no reactivation endpoint.
export const deactivateOrganization = async (
  orgId: number,
  body: DeactivateOrganizationBody
) => {
  const response = await http.post(`${BASE_PATH}/${orgId}/deactivate`, body);
  return response;
};
